
import dynamicIcon from '~/mixins/dynamic-icon';

export default {
    name: 'CartIcon',
    mixins: [dynamicIcon]
};
